import { Skeleton } from '@/components/ui/skeleton/skeleton.component';

export const ProductSkeleton = () => {
  return (
    <>
      {Array.from(Array(8).keys()).map((i) => (
        <div key={i} className="rounded shadow border border-light-gray flex-1">
          <div className="px-4 py-2 border-b border-light-gray">
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="py-3 px-4 space-y-2">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8" />
            <div className="h-[1px] border-b border-light-gray" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4" />
            <Skeleton className="h-4 w-10" />
          </div>
        </div>
      ))}
    </>
  );
};
